import zIndex from "@mui/material/styles/zIndex";
import React, { useEffect } from "react";

type Props = {
  index: number;
  active: boolean;
  isOverview: boolean;
};

const CustomMarker = ({ index, active, isOverview }: Props) => {
  const color = active ? "#D82A3F" : "#C5C8CC";

  const desktopSVG = (
    <svg
      width="30"
      height="40"
      viewBox="0 0 30 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={active ? "z-100" : ""}
    >
      <path
        d="M30 15.2937C30 27.3335 20.3006 36.3791 16.5005 39.4606C15.618 40.1769 14.3692 40.1813 13.478 39.4759C9.66512 36.449 0 27.5693 0 15.2937C0 6.84647 6.71546 0 15.0011 0C23.2867 0 30 6.84647 30 15.2937Z"
        fill={color}
      />
      <rect x="4" y="4" width="22" height="22" rx="11" fill="white" />
      <text
        x="15"
        y="20"
        fill="black"
        fontWeight="semibold"
        fontSize="14"
        textAnchor="middle"
        className="label-text"
      >
        {index + 1}
      </text>
    </svg>
  );

  return desktopSVG;
};

export default CustomMarker;
